import { apiRequestAsyncThunk } from "../../thunk/CommonThunk";
import {
    CREATE_TAG,
    GET_ALL_TAGS,
    UPDATE_TAG,
    GET_ALL_TAG_GROUP_AND_TAGS,
    UPDATE_TAG_GROUP,
    CREATE_TAG_GROUP,
    GET_ALL_VARIANTS_TAGS,
    UPSERT_ALL_VARIANTS_TAGS,
    UPSERT_TAGS_BY_VARIANT_ID,
    DELETE_ALL_VARIANTS_TAGS,
    DELETE_TAGS_BY_VARIANT_ID,
    DELETE_TAGS_BY_VARIANT_IDS,
    GET_ALL_DISCOUNT,
    GET_DISCOUNT_DETAIL_BY_ID,
    GET_ALL_TAG_GROUPS,
    GET_EVERY_VARIANT
} from "../../api/Api";

export const createTagAction = (data) => apiRequestAsyncThunk({
    request_details: CREATE_TAG(data),
    messages: {
        loading: 'saving tag',
        done: 'saved',
        error: 'Error:'
    }
});

export const getAllTagsAction = () => apiRequestAsyncThunk({
    request_details: GET_ALL_TAGS,
    messages: {
        loading: 'Loading tags',
        done: 'Loaded all tags',
        error: 'Error loading tags'
    }
});

export const editTagAction = (data) => apiRequestAsyncThunk({
    request_details: UPDATE_TAG(data),
    messages: {
        loading: 'Saving edited tag',
        done: 'Saved',
        error: 'Error saving tag'
    }
});

export const getAllTagGroupsAction = () => apiRequestAsyncThunk({
    request_details: GET_ALL_TAG_GROUPS,
    messages: {
        loading: 'Loading tag groups',
        done: 'Loaded all tag groups',
        error: 'Error loading tag groups'
    }
});
export const getAllTagGroupAndTagsAction = () => apiRequestAsyncThunk({
    request_details: GET_ALL_TAG_GROUP_AND_TAGS,
    messages: {
        loading: 'Loading tag groups & tags',
        done: 'Loaded all tag groups & tags',
        error: 'Error loading tag groups & tags'
    }
});
export const createTagGroupAction = (data) => apiRequestAsyncThunk({
    request_details: CREATE_TAG_GROUP(data),
    messages: {
        loading: 'Updating tag group',
        done: 'Updated tag group',
        error: 'Error updating tag group'
    }
});
export const updateTagGroupAction = (data) => apiRequestAsyncThunk({
    request_details: UPDATE_TAG_GROUP(data),
    messages: {
        loading: 'Updating tag group',
        done: 'Updated tag group',
        error: 'Error updating tag group'
    }
});

export const storeAllTagsAction = (tags) => ({
    type: 'ALL_TAGS',
    payload: tags
});

export const storeAllTagGroupsAction = (tagGroups) => ({
    type: 'ALL_TAG_GROUPS',
    payload: tagGroups
});

export const storeAllVariantsAndTagsAction = (tagGroups) => ({
    type: 'ALL_VARIANTS_TAGS',
    payload: tagGroups
});
export const storeEveryVariant = (variants) => ({
    type: 'EVERY_VARIANT',
    payload: variants
});
export const getAllVariantsAndTags = () => apiRequestAsyncThunk({
    request_details: GET_ALL_VARIANTS_TAGS,
    messages: {
        loading: 'Loading variants',
        done: 'Variants loaded',
        error: 'Error loading variants'
    }
});
export const getAllVariants = () => apiRequestAsyncThunk({
    request_details: GET_EVERY_VARIANT,
    messages: {
        loading: 'Loading variants',
        done: 'Variants loaded',
        error: 'Error loading variants'
    }
});
export const upsertAllVariantsAndTags = (data) => apiRequestAsyncThunk({
    request_details: UPSERT_ALL_VARIANTS_TAGS(data),
    messages: {
        loading: 'Saving batch',
        done: 'Batch saved',
        error: 'Error saving batch'
    }
});
export const deleteAllTagsFromVariants = (data) => apiRequestAsyncThunk({
    request_details: DELETE_ALL_VARIANTS_TAGS(data),
    messages: {
        loading: 'Deleting batch',
        done: 'Batch deleted',
        error: 'Error deleting batch'
    }
});
export const upsertTagsByVariantId = (data) => apiRequestAsyncThunk({
    request_details: UPSERT_TAGS_BY_VARIANT_ID(data),
    messages: {
        loading: 'Saving variant tags',
        done: 'Variant tags saved',
        error: 'Error saving variant tags'
    }
});
export const deleteTagsByVariantId = (variantId) => apiRequestAsyncThunk({
    request_details: DELETE_TAGS_BY_VARIANT_ID(variantId),
    messages: {
        loading: 'Deleting all tags from variant',
        done: 'Variant tags deleted',
        error: 'Error deleting variant tags'
    }
});
export const deleteTagsByVariantIds = (variantIds) => apiRequestAsyncThunk({
    request_details: DELETE_TAGS_BY_VARIANT_IDS(variantIds),
    messages: {
        loading: 'Deleting all tags from variants',
        done: 'Variant tags deleted',
        error: 'Error deleting variant tags'
    }
});
export const getAllDiscount = () => apiRequestAsyncThunk({
    request_details: GET_ALL_DISCOUNT,
    messages: {
        loading: 'Loading discounts',
        done: 'Discounts loaded',
        error: 'Error loading discounts'
    }
});
export const getDiscountDetailById = (id) => apiRequestAsyncThunk({
    request_details: GET_DISCOUNT_DETAIL_BY_ID(id),
    messages: {
        loading: 'Loading discount',
        done: 'Discount loaded',
        error: 'Error loading discount'
    }
});
export const storeAllDiscount = (discounts) => ({
    type: 'ALL_DISCOUNTS',
    payload: discounts
});